import { render, staticRenderFns } from "./XId.vue?vue&type=template&id=7827ee9b&"
import script from "./XId.vue?vue&type=script&lang=js&"
export * from "./XId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports